
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"38","height":"38","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19 0C8.524 0 0 8.524 0 19c0 10.477 8.524 19 19 19 10.477 0 19-8.523 19-19C38 8.524 29.477 0 19 0zm7.308 20.462h-5.846v5.846a1.462 1.462 0 11-2.924 0v-5.846h-5.846a1.462 1.462 0 110-2.924h5.846v-5.846a1.462 1.462 0 112.924 0v5.846h5.846a1.462 1.462 0 110 2.924z"}})])
          )
        }
      }
    